module.exports = __webpack_public_path__ + "media/images/smart_phone/btn_logout-6c4cf224e8b692d311e6633e7b00d0aa.png";